// @flow

import React from 'react';
import { connect } from 'react-redux';
import NewsPreview from './newsPreview';
import { getHighlightedItem } from '../../../store/news';
import { getNewsReadMoreLabel } from '../../../store/newsSettings';
import type { NewsItem } from '../../../types';

type StateProps = {|
  item: ?NewsItem,
  readMoreLabel: string,
|};

const NewsPreviewHighlight = ({ item, readMoreLabel }: StateProps) => (
  (item ? (
    <NewsPreview
      highlight
      key={item.title}
      readMoreLabel={readMoreLabel}
      image={item.image}
      date={item.date}
      title={item.title}
      intro={item.intro}
      link={item.link}
    />
  ) : null)
);

const mapStateToProps = (state: any): StateProps => ({
  item: getHighlightedItem(state),
  readMoreLabel: getNewsReadMoreLabel(state),
});

export default connect<any, any, StateProps, any, any, any>(mapStateToProps)(NewsPreviewHighlight);
